import React from 'react';
import { NavLink } from '@mantine/core';
import type { MobileMenuNavItem, MobileMenuTopLevelNode } from 'common-ui';
import { CmsContentSection, Icon, inspectorMode } from 'common-ui';
import type { DLClickEventHandlerProps } from 'tsconfig/types';
import RenderLevel3Menu from './RenderLevel3Menu';

type Props = {
  menuItems: MobileMenuTopLevelNode;
  onBack: () => void;
  dlClickEventHandler: DLClickEventHandlerProps;
};

const RenderLevel2Menu = ({ menuItems, onBack, dlClickEventHandler }: Props): React.JSX.Element | null => {
  if (!menuItems) {
    return null;
  }

  const level2Menu = menuItems?.children?.map(menuItem => {
    if (menuItem.contentType === 'navigation') {
      const navItem = menuItem as MobileMenuNavItem;
      return (
        <NavLink
          key={navItem.id}
          className="level2Link"
          label={navItem.title}
          rightSection={<Icon kind="chevron-down" size="m" />}
          onClick={() => dlClickEventHandler(`${menuItems.title}:${navItem.title}`)}
          {...inspectorMode(navItem.id, 'title')}
        >
          <RenderLevel3Menu
            level3MenuContent={navItem}
            level2MenuContentTitle={menuItems.title}
            dlClickEventHandler={dlClickEventHandler}
          />
        </NavLink>
      );
    }

    return (
      <div className="navMenuContent" key={menuItem.id}>
        <CmsContentSection
          contentJsonList={[menuItem.contentItem]}
          dlClickEventHandler={(data: string) => {
            dlClickEventHandler(`${menuItems.title}:${data}`);
          }}
        />
      </div>
    );
  });

  return (
    <>
      <div
        className="navMenuBackLink"
        onClick={onBack}
        role="button"
        tabIndex={0}
        onKeyDown={e => (e.key === 'Enter' || e.key === '') && onBack()}
      >
        <Icon kind="back" size="xs" /> <span>{menuItems?.title}</span>
      </div>
      {level2Menu}
    </>
  );
};

export default RenderLevel2Menu;
